import { newsTagAdd } from "./news-tag-add/news-tag-add.module";
import { newsTagMain } from "./news-tag-main/news-tag-main.module";
import { newsTagEdit } from "./news-tag-edit/news-tag-edit.module";
import { newsTagList } from "./news-tag-list/news-tag-list.module";
import { NewsTagService } from "./news-tag.service";

export const newsTag = angular
  .module("components.news-tag", [
    newsTagMain,
    newsTagAdd,
    newsTagEdit,
    newsTagList,
  ])
  .service("NewsTagService", NewsTagService).name;



// WEBPACK FOOTER //
// ./src/app/components/news-tag/news-tag.module.js